angular.module('bookingApp').filter('filterProperties',['sessionFactory', function(session) {
    return function(propertyObjects, propertyIdsToFilter, sellMode) {
        // Server side gives us a list of property IDs to make available, if it's empty, return no properties
        if(!propertyIdsToFilter) {
            return [];
        }

        // Create an array of acceptable properties
        var out = [],
            filter,
            i, c,
            mappedIdsFromCategorySelection;

        // Loop the property IDs given by the server as these will be in a specific order
        angular.forEach(propertyIdsToFilter, function(propertyId) {
            if (propertyObjects.hasOwnProperty(propertyId)) {
                out.push(propertyObjects[propertyId]);
            }
        });

        // Now we'll filter on the user filters
        return out.filter(function(property) {
            // filter out disabled property and those without regions
            if(!property.isEnabled || !property.region || !property.subRegion){
                return false;
            }
            if(session.template.hideUnavailableContexts && sellMode[property.id] === 0){
                return false;
            }
            // Loop the filters selected
            for(i = 0, c = session.propertyFilters.filters.length; i < c; i++) {
                // Grab the filter
                filter = session.propertyFilters.filters[i];

                // Ensure the filter is not empty and enabled
                if(!filter.enabled || !filter.selected || filter.selected.length === 0) {
                    continue;
                }

                // Otherwise filter based on what type of filter it is.
                switch (filter.label) {
                    case 'Country':
                        // Check the country ID of this BC is selected.
                        if(filter.selected.indexOf(property.countryId) < 0) {
                            return false;
                        }
                        break;
                    case 'City / Region':
                        // Check the region ID of this BC is selected.
                        if(filter.selected.indexOf(property.regionId) < 0) {
                            return false;
                        }
                        break;
                    case 'Location':
                        // Check the sub region ID of this BC is selected.
                        if(filter.selected.indexOf(property.subRegionId) < 0) {
                            return false;
                        }
                        break;
                    case 'Property Type':
                        if (filter.selected.indexOf(property.subTypeId) < 0) {
                            return false;
                        }
                        break;
                    case 'Rating':
                        if (parseFloat(property.starRating) < parseFloat(filter.selected)) {
                            return false;
                        }
                        break;
                    case 'Facilities':
                        var chosenFilters = filter.selected;
                        chosenFilters = chosenFilters.map(function(item){
                            return parseInt(item);
                        });
                        if (_.intersection(chosenFilters, property.facilities).length === 0) {
                            return false;
                        }
                        break;
                    case 'Additional Options':
                        // If we haven't already calculated it, figure out what property ID we can have based on this
                        // filter
                        if (!mappedIdsFromCategorySelection) {
                            mappedIdsFromCategorySelection = [];
                            angular.forEach(filter.selected, function(categoryId) {
                                mappedIdsFromCategorySelection = _.union(mappedIdsFromCategorySelection, session.propertyCategoryMapping[categoryId]);
                            });
                        }
                        if (mappedIdsFromCategorySelection.indexOf(property.id.toString()) < 0) {
                            return false;
                        }
                        break;
                }
            }
            return true;
        });
    };
}]);

angular.module('bookingApp').filter('multiPropFiltersToArray',['$filter', function(){
    return function(input){
        var out = [], i = 0;
        for(var filter in input){
            out.push(
                {
                    id: filter,
                    val: input[filter]
                }
            );
        }
        out.sort(function(a, b){
            if(a.val < b.val) return -1;
            if(a.val > b.val) return 1;
            return 0;
        });
        return out;
    };
}]);

angular.module('bookingApp').filter('regionalFilter', ['$filter', function(){
    return function(input, filtersOn){
        var selected = null, out = [];
        if(!filtersOn){
            return input;
        }
        angular.forEach(input, function(option){
            angular.forEach(filtersOn, function(filter){
                if(parseInt(option.id) === parseInt(filter)){
                    out.push(option);
                    return out;
                }
            });
        });
        return out;
    };
}]);